import React, { useMemo } from 'react';
import { WorkbenchLocaleContextType } from './types';
import { WorkbenchLocaleContext } from './WorkbenchLocaleContext';

interface WorkbenchLocaleProviderProps extends WorkbenchLocaleContextType {
  children?: React.ReactNode;
}

/**
 * A component that can be used in UFE workbenches to provide locales to its own files and external components,
 * or in storybook.
 */
export const WorkbenchLocaleProvider = ({
  children,
  workbenchLocale,
}: WorkbenchLocaleProviderProps) => {
  const contextValue = useMemo<WorkbenchLocaleContextType>(
    () => ({ workbenchLocale }),
    [workbenchLocale],
  );

  return (
    <WorkbenchLocaleContext.Provider value={contextValue}>
      {children}
    </WorkbenchLocaleContext.Provider>
  );
};
